import React, { useEffect } from 'react'
import PartIcon from '../../../assets/icons/PartIcon'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useSelector } from 'react-redux';
function WhyUsSection() {
  const contentData = useSelector(state => state.Data.contentData);
  
  return (
    <section className='mt-[50px]  relative section-bg'>
  
      <div className=' top-0 left-0 w-full h-full bg-black/40 py-[20px]'>
        <div   className='container2'>
           <div>
            <h2 className='text-white montserrat  text-[48px] font-[600] text-center max-[700px]:text-[38px] max-[500px]:text-[34px] '>{contentData?.section_5}</h2>
           </div>


            <div className='grid grid-cols-4 mt-[20px] gap-[100px] max-[1300px]:gap-[50px] max-[1050px]:gap-[30px] max-[800px]:grid-cols-2 max-[600px]:grid-cols-1'>
              <div className='flex flex-col items-center gap-[10px] '>
                <div className='w-[90px] h-[90px] border border-[3px] border-white rounded-full flex items-center justify-center resp_svg max-[900px]:h-[70px] max-[900px]:w-[70px]'>
                  <PartIcon />
                </div>
                <h3 className='text-center text-white text-[22px] max-[900px]:text-[19px] font-[600]'>{contentData?.why_1_title}</h3>
                <p className='text-white text-[14px] text-center'>{contentData?.why_1_desc}</p>
              </div>
              <div className='flex flex-col items-center gap-[10px] '>
                <div className='w-[90px] h-[90px] border border-[3px] border-white rounded-full flex items-center justify-center resp_svg max-[900px]:h-[70px] max-[900px]:w-[70px]'>
                  <PartIcon />
                </div>
                <h3 className='text-center text-white text-[22px] max-[900px]:text-[19px] font-[600]'>{contentData?.why_2_title}</h3>
                <p className='text-white text-[14px] text-center'>{contentData?.why_2_desc}</p>
              </div>
              <div className='flex flex-col items-center gap-[10px] '>
                <div className='w-[90px] h-[90px] border border-[3px] border-white rounded-full flex items-center justify-center resp_svg max-[900px]:h-[70px] max-[900px]:w-[70px]'>
                  <PartIcon />
                </div>
                <h3 className='text-center text-white text-[22px] max-[900px]:text-[19px] font-[600]'>{contentData?.why_3_title}</h3>
                <p className='text-white text-[14px] text-center'>{contentData?.why_3_desc}</p>
              </div>
              <div className='flex flex-col items-center gap-[10px] '>
                <div className='w-[90px] h-[90px] border border-[3px] border-white rounded-full flex items-center justify-center resp_svg max-[900px]:h-[70px] max-[900px]:w-[70px]'>
                  <PartIcon />
                </div>
                <h3 className='text-center text-white text-[22px] max-[900px]:text-[19px] font-[600]'>{contentData?.why_4_title}</h3>
                <p className='text-white text-[14px] text-center'>{contentData?.why_4_desc}</p>
              </div>
              
            </div>
        </div>
      </div>
    </section>
  )
}

export default WhyUsSection